// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader-container {
  background-color: var(--pure-white-color);
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loader-wrapper {
  display: flex;
  flex-direction: column;
  position: absolute;
  inset: 0;
  margin: auto;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
}
.loader-wrapper .loader-image {
  width: 100px;
}

.bouncing-loader {
  display: flex;
  gap: 0.5rem;
  justify-content: center;
}

.bouncing-loader > div {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #a3a1a1;
  opacity: 1;
  animation: bouncing-loader 0.6s infinite alternate;
}

@keyframes bouncing-loader {
  to {
    opacity: 0.5;
    transform: translateY(-8px);
  }
  0% {
    background-color: #1E67B1;
  }
  33% {
    background-color: #2882dd;
  }
  50% {
    background-color: #2f96fd;
  }
  75% {
    background-color: #5AB849;
  }
  100% {
    background-color: #7dff67;
  }
}
.bouncing-loader > div:nth-child(2) {
  animation-delay: 0.2s;
}

.bouncing-loader > div:nth-child(3) {
  animation-delay: 0.4s;
}

.bouncing-loader > div:nth-child(4) {
  animation-delay: 0.6s;
}

.bouncing-loader > div:nth-child(5) {
  animation-delay: 0.8s;
}`, "",{"version":3,"sources":["webpack://./src/component/common/loader/Loader.scss"],"names":[],"mappings":"AAAA;EACE,yCAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AACF;AACE;EACE,YAAA;AACJ;;AAGA;EACE,aAAA;EACA,WAAA;EACA,uBAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,UAAA;EACA,kDAAA;AAAF;;AAGA;EACE;IACE,YAAA;IACA,2BAAA;EAAF;EAEA;IACE,yBAAA;EAAF;EAEA;IACE,yBAAA;EAAF;EAEA;IACE,yBAAA;EAAF;EAEA;IACE,yBAAA;EAAF;EAEA;IACE,yBAAA;EAAF;AACF;AAGA;EACE,qBAAA;AADF;;AAIA;EACE,qBAAA;AADF;;AAGA;EACE,qBAAA;AAAF;;AAEA;EACE,qBAAA;AACF","sourcesContent":[".loader-container{\n  background-color: var(--pure-white-color);\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.loader-wrapper {\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  inset: 0;\n  margin: auto;\n  align-items: center;\n  justify-content: center;\n  gap: 1.5rem;\n\n  .loader-image{\n    width: 100px;\n  }\n}\n\n.bouncing-loader {\n  display: flex;\n  gap: 0.5rem;\n  justify-content: center;\n}\n\n.bouncing-loader > div {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background-color: #a3a1a1;\n  opacity: 1;\n  animation: bouncing-loader 0.6s infinite alternate;\n}\n\n@keyframes bouncing-loader {\n  to {\n    opacity: 0.5;\n    transform: translateY(-8px);\n  }\n  0% {\n    background-color: #1E67B1;\n  }\n  33% {\n    background-color: #2882dd;\n  }\n  50% {\n    background-color: #2f96fd;\n  }\n  75% {\n    background-color: #5AB849;\n  }\n  100% {\n    background-color: #7dff67;\n  }\n}\n\n.bouncing-loader > div:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.bouncing-loader > div:nth-child(3) {\n  animation-delay: 0.4s;\n}\n.bouncing-loader > div:nth-child(4) {\n  animation-delay: 0.6s;\n}\n.bouncing-loader > div:nth-child(5) {\n  animation-delay: 0.8s;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
